import * as actions from './actionsTypes';

const initialData = {
  loading: false,
  saveLoading: false,
  formacionColaborador: null,
  formacionColaboradorError: "",
  formError: ""
}

export default function FormacionColaboradorReducer(state = initialData, action) {
  switch (action.type) {
    case actions.LOADING_FORMACION_COLABORADOR:
      return { ...state, loading: action.payload };
    case actions.SAVE_LOADING_FORMACION_COLABORADOR:
      return { ...state, saveLoading: action.payload };
    case actions.GET_FORMACION_COLABORADOR:
      return {
        ...state,
        formacionColaborador: action.payload.formacionColaborador,
      };
    case actions.FORM_FAIL:
      return { ...state, formError: action.payload };
    case actions.FORMACION_COLABORADOR_FAIL:
      return { ...state, formacionColaboradorError: action.payload };  


    default:
      return state;
  }
}